export default {
  "LABEL_WARNING": 'UYARI',
  "LABEL_SUCCESS": 'TEBRİKLER',
  "LABEL_DELETE": 'SİL',
  "LABEL_CANCEL": 'VAZGEÇ',
  
  "FORM_REQUIRED": 'Boş alan bırakmayınız', 
  "FORM_REQUIRED_GENDER": 'Cinsiyet seçimi yapınız',

  "CONFIRM_ADDRESS_DELETED": 'Seçilen adres kalıcı olarak silinecektir.'
}